<template lang="pug">
  .component-client-action-buttons
    CityReveal(:cityProp="item")
      .dropdown-buttons
        button.button Edit
    //.dropdown-buttons
      ActionButton(:action="remove", :confirm="true") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'
  import CommonCostButtonModal from './CommonCostButtonModal'
  import ActionButton from '../ActionButton'
  import CityReveal from "../../../../pages/backoffice/CityReveal.vue";

  export default {
    name: 'CityButtons',
    components: {CityReveal, ActionButton, CommonCostButtonModal, ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        return KeplerBackofficeSdk.commonCosts.select(this.item).delete(() => {
          MaggieHelper.notification('delete-esit', 'Cost removed')
          this.$emit('itemUpdated')
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CityButtons.vue?a5f9e5e2